<template>
  <ContentWrapper class="mt-4">
    <div class="bg-white shadow border-b rounded-lg overflow-hidden">
      <div>
        <img v-bind:src="image" class="block w-full" />
      </div>
      <div class="px-4 text-sm leading-normal mt-4">
        <div class="pb-4">
          The Philippine Army Finance Center Producers Integrated Cooperative
          (PAFCPIC), commonly known as PAPSI, is a multi-awarded cooperative
          that provides savings, loan, and other financial services to members
          of the Armed Forces of the Philippines (AFP).
        </div>
        <div class="pb-4">
          PAFCPIC serves military and civilian personnel of the Philippine Army,
          Philippine Navy, and Philippine Air Force—both active and retired—as
          well as AFP Reservists, Honorably-Separated AFP Personnel, and their
          qualified immediate dependents. Today, it proudly serves more than
          200,000 Ka-may-ari nationwide through its Main Office in Fort
          Bonifacio, Taguig City, Satellite Offices, and Liaison Offices across
          the country.
        </div>
        <div class="pb-4">
          Recognized for its excellence and commitment to service, PAFCPIC has
          received numerous local and national awards, including the Gawad para
          sa Pinakatanging Kooperatiba (Gawad PITAK), the Philippine Quality
          Challenge Level 2 Award, and recognition as one of the Top 100 Best
          Employers in the Philippines for 2023. In 2024, PAFCPIC earned the
          Great Place to Work® Certification and is currently ISO 9001:2015
          Certified, reflecting its commitment to quality management and
          continuous improvement.
        </div>
        <div class="pb-4">
          PAFCPIC is registered with the Cooperative Development Authority (CDA)
          under Registry No. 9520-16000421 dated 16 October 2009, and continues
          to uphold its commitment to providing accessible, reliable, and
          member-focused financial services.
        </div>
      </div>
      <div class="pb-4 px-4">
        <ButtonControl @click="this.$router.push('/satellite-offices')">
          {{ lang("lbl_0000126") }}
        </ButtonControl>
      </div>
    </div>
  </ContentWrapper>
</template>

<script>
import ContentWrapper from "./../../components/controls/ContentWrapperControl.vue";
import ButtonControl from "@/components/controls/ButtonControl.vue";
import mixin from "./../../mixin.js";

export default {
  mixins: [mixin],
  components: {
    ContentWrapper,
    ButtonControl,
  },
  data() {
    return {
      image: "",
    };
  },
  mounted() {
    this.$emit("shownavbar", {
      title: this.lang("lbl_0000125"),
      show: true,
      back: true,
    });
    this.$emit("nofooter", false);
    this.image = this.getMediaPath("/misc/papsi-ho.jpg");
  },
};
</script>
